<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-empty */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

import DatePicker from "vue2-datepicker";
import Switches from "vue-switches";
import Multiselect from "vue-multiselect";
import HotelDatePicker from "vue-hotel-datepicker";
import NumberInputSpinner from "vue-number-input-spinner";
import { icons } from "../data-fontawesome";
import {
  urlMethods,
} from "@/state/helpers";

export default {
    page: {
        title: "Phiên bán hàng",
        meta: [
        {
            name: "description",
            content: appConfig.description,
        },
        ],
    },
    components: {
        Layout,
        HotelDatePicker,
        DatePicker,
        Switches,
        Multiselect,
        NumberInputSpinner
    },
    data() {
        return {
            title: "Phiên bán hàng",
            icons: icons,
            loadingArr: [],
            cashendValue: 0,
            isDisabled: false,
            loadingMain: true,
            breadcrumbData: [
                {text: "Trang chủ", to: { name: 'default' }},
                {text: "Phiên bán lẻ",to: { name: 'session' }},
                {text: "Chi tiết",active: true}
            ],
            session: {
                id: 0
            },
            orders: [],
            fields: [
                "id",
                {
                key: "name",
                label: "Mã đơn hàng"
                },
                {
                key: "customer_name",
                label: "Khách hàng"
                },
                {
                key: "created_at",
                label: "Ngày mua"
                },
                {
                key: "pos_name",
                label: "Điểm bán lẻ"
                },
                {
                key: "sale_man_name",
                label: "NVBH"
                },
                {
                key: "amount_total",
                label: "Tổng",
                formatter: value => {
                    if(typeof value == 'undefined' || value == null) return 0;
                    return value.toLocaleString() + ' ₫';
                }
                },
                {
                key: "status",
                label: "Trạng thái"
                }
            ]
        };
    },
    computed: {
        currentUser() {
            let user = localStorage.getItem('currentUser') || false;
            return user ? JSON.parse(user) : false;
        },
        session_name(){
          if(typeof this.session == 'undefined' || typeof this.session.name == 'undefined') return '';
            return this.session.name;
        },
    },
    methods: {
        ...urlMethods,
        removeLoading(_id = ''){
        this.loadingArr = this.loadingArr.filter(function(item){return item != _id;});
        },
        mapStatus(state = ''){
            return `<span class="badge font-size-12 bg-${window.mapStatusTag(state)}">${window.mapStatus(state)}</span>`;
        },
        isLoading(name = ''){return this.loadingArr.includes(name)},
        formatMoney(input){
            if(typeof input == 'undefined' || input == null || isNaN(input)) return 0;
            return parseFloat(input).toLocaleString('vi-VN');
        },
        async getOrders(){
            let that = this;
            try {
                let res = await that.getUrl('session/order/'+that.session.id);
                if(typeof res == 'undefined' || typeof res.data == 'undefined' || typeof res.error == 'undefined' || typeof res.message == 'undefined'){                        
                    throw 'Không thế kết nối server';
                }
                this.orders = res.data ? res.data : [];
            } catch (error) {
                console.log(error);
            }
        },
        async closeAndCompleteSession(){
            let that = this;
            that.isDisabled = true;
            Swal.fire({title: 'Thao tác không thể hoàn lại. Bạn có chắc chắn?',showCancelButton: true,confirmButtonText: 'Có. Đóng phiên & Vào sổ ngay',cancelButtonText: 'Không. Bỏ qua'}).then((result) => {if (result.isConfirmed) {
                that.loadingArr.push('complete');
                setTimeout(async () => {
                    try {
                        if (that.session.state === 'opened') {
                            let closeRes = await that.getUrl('session/close/'+that.session.id);
                            if(typeof closeRes == 'undefined' || typeof closeRes.data == 'undefined' || typeof closeRes.error == 'undefined'){
                                throw 'Không thể kết nối server';
                            }
                            if(closeRes.error){ throw closeRes.message; }
                        }
                        let res = await that.getUrl('session/complete/'+that.session.id);
                        if(typeof res == 'undefined' || typeof res.data == 'undefined' || typeof res.error == 'undefined' || typeof res.message == 'undefined'){
                            throw 'Không thể kết nối server';
                        }
                        if(res.error){ throw res.message; }
                        that.$store.dispatch("sale/setNoti", { 'text': 'Đóng phiên & Vào sổ thành công', 'type': 'success'});
                        that.getSession();
                    } catch (error) {
                        console.log(error);
                        let text = (typeof error == 'string' ? error : JSON.stringify(error));
                        that.$store.dispatch("sale/setNoti", { 'text': text, 'type': 'error'});
                    }
                    that.isDisabled = false;
                    that.removeLoading('complete');
                }, 100);
            }else{that.isDisabled = false;}});
        },
        async getSession(){
            this.$bvModal.hide('modal-cashend');
            this.session.id = this.$route.params.id;
            try {
                let res = await this.getUrl('session/'+this.session.id);
                if(typeof res.data == 'undefined' || !res.data || res.data == null || typeof res.data.id == 'undefined'){
                    throw 'Không thể lấy thông tin phiên bán hàng';
                }
                this.session = res.data;
                this.loadingMain = false;
            } catch (error) {
                let text = (typeof error  == 'string' ? error : JSON.stringify(error));this.$store.dispatch("sale/setNoti", { 'text' :  text, 'type' : 'error'});
                this.loadingMain = false;
            }
        },
        async saveCashendValue(){
            let that = this;
            that.isDisabled = true;
            that.loadingArr.push('setup');
            setTimeout(async () => {
                try {
                    let res = await that.postUrl({'url' : 'session/cashbox', 'data' : {"session_id" :  that.session.id, "coin_value" : that.cashendValue}});
                    if(typeof res == 'undefined' || typeof res.data == 'undefined' || typeof res.error == 'undefined' || typeof res.message == 'undefined'){                        
                        throw 'Không thế kết nối server';
                    }
                    if(res.error){
                        throw res.message;
                    }
                    if(!res.data){
                        throw 'Lỗi! Không thể tạo đơn hàng';
                    }
                    that.$store.dispatch("sale/setNoti", { 'text' :  'Xử lý thành công', 'type' : 'success'});
                    that.getSession();
                } catch (error) {
                    let text = (typeof error  == 'string' ? error : JSON.stringify(error));
                    that.$store.dispatch("sale/setNoti", { 'text' :  text, 'type' : 'error'});
                }
                that.isDisabled = false;
                that.removeLoading('setup');
            }, 100);
        }
    },
    mounted() {
        let that = this;
        setTimeout(() => {
            that.getSession();that.getOrders();
        }, 50);
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            if(modalId == 'modal-cashend'){
                that.cashendValue = that.session.difference * -1;
                setTimeout(() => {
                    if(typeof that.$refs.cashendValue != 'undefined' && typeof that.$refs.cashendValue.$el != 'undefined') that.$refs.cashendValue.$el.focus();
                }, 100);
            }
        });
    },
};
</script>

<template>
  <Layout>
  <div :class="loadingMain ? 'flex-middle-full' : 'hidden'"><i class="fas fa-spinner fa-spin font-size-34"></i></div>
    <div v-if="!loadingMain">
        <div class="page-header">
            <div class="page-title"><h4 class="mb-0 font-size-18">THÔNG TIN PHIÊN BÁN HÀNG</h4></div>
            <b-breadcrumb :items="breadcrumbData" class="m-0 p-0"></b-breadcrumb>
        </div>
        <div class="page-title-box d-flex align-items-center justify-content-between pb-3">
            <div class="page-title-right">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6  mb-0">
                <div class="card p-0  mb-0">
                    <div class="card-body p-0  mb-0">
                        <div class="table-responsive">
                        <table class="table table-striped mb-0" style="background: white;">
                            <tbody>
                                <tr>
                                    <td width="90px">Tên phiên</td>
                                    <th scope="row"><span v-html="session_name"></span> <span style="margin-left: 5px;" :class="'badge font-size-12 bg-'+session.status_class">{{ session.status_name }}</span></th>
                                </tr>
                                <tr>
                                    <td>Điểm bán lẻ</td>
                                    <th scope="row">{{session.pos_name}}</th>
                                </tr>
                                <tr>
                                    <td>Ngày mở</td>
                                    <th scope="row">{{session.start_at}}</th>
                                </tr>
                                <tr>
                                    <td>Ngày đóng</td>
                                    <th scope="row">{{session.stop_at}}</th>
                                </tr>
                                <tr v-if="session.state == 'opened' || session.state == 'closing_control'">
                                    <td>Xử lý</td>
                                    <th scope="row">
                                        <b-button variant="success" style="margin-left: 5px;" v-b-modal.modal-cashend size="sm" v-if="session.state == 'opened' && session.difference != 0" :disabled="isDisabled"><i v-if="!isLoading('setup')" class="bx bx-money align-middle font-size-14"></i><i v-if="isLoading('setup')" class="fas fa-spinner fa-spin font-size-14"></i> Thiết lập số dư cuối kì</b-button>
                                        <b-button variant="danger" style="margin-left: 5px;" @click="closeAndCompleteSession()" size="sm" v-if="session.state == 'opened' && session.difference == 0 || session.state == 'closing_control'" :disabled="isDisabled"><i v-if="!isLoading('complete')" class="bx bx-check align-middle font-size-14"></i><i v-if="isLoading('complete')" class="fas fa-spinner fa-spin font-size-14"></i> Đóng phiên & Vào sổ</b-button>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6  mb-0">
                <div class="card p-0  mb-0">
                    <div class="card-body p-0 mb-0 session-summary">
                        <div class="row"><div class="col-md-8 col-8 bold-text">Số dư đầu kì:</div><div class="col-md-4 col-4">{{ formatMoney(session.balance_start) }} <sup>₫</sup></div></div>
                        <div class="row border-top"><div class="col-md-8 col-8 bold-text">+ Giao dịch:</div><div class="col-md-4 col-4">{{ formatMoney(session.entry) }} <sup>₫</sup></div></div>
                        <div class="row bold-text border-top"><div class="col-md-8 col-8">= Số dư cuối phiên lý thuyết:</div><div class="col-md-4 col-4">{{ formatMoney(session.balance_end) }} <sup>₫</sup></div></div>
                        <div class="row bold-text border-top"><div class="col-md-8 col-8">Số dư cuổi kì thực tế:</div><div class="col-md-4 col-4">{{ formatMoney(session.balance_end_real) }} <sup>₫</sup></div></div>
                        <div class="row bold-text border-top"><div class="col-md-8 col-8">Chênh lệch:</div><div class="col-md-4 col-4">{{ formatMoney(session.difference) }} <sup>₫</sup></div></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" style="margin-top: 15px;">
          <b-tabs content-class="p-3" nav-wrapper-class="nav-item" class="pt-2" nav-class="nav-tabs-custom">
            <b-tab title="Tổng hợp theo Phương thức thanh toán" active>
                <div class="table-responsive">
                    <table class="table table-bsessioned mb-0" style="min-height: 100px">
                        <thead class="table-light">
                            <tr>
                                <th scope="row">Tham chiếu</th>
                                <th scope="row">Sổ nhật ký</th>
                                <th scope="row">Đầu kì</th>
                                <th scope="row">Giao dịch</th>
                                <th scope="row">Cuối kì</th>
                                <th scope="row">Chênh lệch</th>
                                <th scope="row">Trang thái</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in session.payments" :key="item.id">
                                <td>{{ item.journal_id[1] }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ formatMoney(item.balance_start) }} <sup>₫</sup></td>
                                <td>{{ formatMoney(item.total_entry_encoding) }} <sup>₫</sup></td>
                                <td>{{ formatMoney(item.balance_end_real) }} <sup>₫</sup></td>
                                <td>{{ formatMoney(item.difference) }} <sup>₫</sup></td>
                                <td v-html="mapStatus(item.state)"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-tab>
          </b-tabs>
        </div>
        <div class="card" style="margin-top: 15px;">
          <b-tabs content-class="p-3" nav-wrapper-class="nav-item" class="pt-2" nav-class="nav-tabs-custom">
            <b-tab title="Đơn hàng trong phiên" active>
                <div class="table-responsive" style="padding: 0px 0px 15px">
                    <b-table id="my-table" class="p-0 m-0 table-striped table-bordered" striped hover :items="orders" :fields="fields">
                        <template v-slot:cell(name)="data">
                        <router-link :to="`/order/${data.item.id}`">{{ data.item.name }}</router-link>                        </template>
                        <template v-slot:cell(status)="data">
                        <span :class="'badge font-size-12 bg-'+data.item.status_class">{{ data.item.status_name }}</span>
                        </template>
                        <template v-slot:cell(customer_name)="data">{{ data.item.customer_name }} - {{ data.item.customer_phone }}</template>
                    </b-table>
                </div>
            </b-tab>
          </b-tabs>
        </div>
    </div>
    <b-modal id="modal-cashend" title="Thiết lập số dư cuối kì" title-class="font-18" hide-footer>
        <b-form-group class="mb-2" label-cols-lg="3" label="Số tiền" label-for="cashendValue" >
            <money class="form-control" :disabled="isDisabled" @keyup.native.enter="saveCashendValue" ref="cashendValue" autocomplete="off" for="cashendValue" v-model="cashendValue"></money>
        </b-form-group>        
        <div class="text-right">
            <i v-if="isDisabled" class="fas fa-spinner fa-spin"></i> <b-button variant="primary" @click="saveCashendValue" :disabled="isDisabled" ><i class="bx bx-check"></i> Xác nhận</b-button>
        </div>
    </b-modal>
  </Layout>
</template>
